import { useFeatureFlag } from '@order/LaunchDarkly';

import { USABLE_NET_BANNER_HEIGHT } from '../constants';

/**
 * Returns the height for the usable net banner based on the feature flag state.
 */
export const useUsableNetBannerHeight = () => {
  const isEnabled = useFeatureFlag('cels-3985-usable-net-enabled');

  return isEnabled ? USABLE_NET_BANNER_HEIGHT : 0;
};
